export default {
  getLocation : function(callback){
    var geolocation = new BMap.Geolocation();
    // 创建地理编码实例    
    var myGeo = new BMap.Geocoder();    
    geolocation.getCurrentPosition(function(r){
      if(this.getStatus() == BMAP_STATUS_SUCCESS){
        var pt = r.point; 
        
        var ggPoint  = new BMap.Point(pt.lng,pt.lat)
        var convertor = new BMap.Convertor()
        var pointArr = []
        pointArr.push(ggPoint)
        convertor.translate(pointArr, 1, 5, function(data){
          if(data.status === 0) {
            window.localStorage.UserLocationLng = data.points[0].lng
            window.localStorage.UserLocationLat =  data.points[0].lat

            // 根据坐标得到地址描述  
            myGeo.getLocation(data.points[0], function(result){  
              callback()  
              if (result){    
                var addComp = result.addressComponents;   
                window.localStorage.ProductDetailDeliveryProvinceCache = addComp.province
                window.localStorage.ProductDetailDeliveryCityCache = addComp.city
                window.localStorage.ProductDetailDeliveryAreaCache =  addComp.district
              }    
            }); 
          }else{
            callback()
          }
        })
      }else {
        callback()
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/util/map.js